import {BaseModel} from '../baseModel';

export class Attachment extends BaseModel<number> {
  resId: number;
  module: string;
  filePath: string;
  fileType: string;
  mimeType: string;
  name: string;
  checksum: number;
  size: number;
}
